<div class="date-set-today-row" [class.date-set-today-disabled]="controlDisabled()">
    <input
        type="checkbox"
        class="form-check-input date-set-today-check"
        [checked]="isSet()"
        [disabled]="controlDisabled()"
        [id]="toggleId() || undefined"
        [attr.aria-label]="checkboxAriaLabel()"
        (change)="onCheckboxChange($any($event.target).checked)"
    />
    <div class="date-set-today-picker">
        <wj-input-date
            [ngModel]="dateValue()"
            (ngModelChange)="onPickerChange($event)"
            [ngModelOptions]="{ standalone: true }"
            [name]="wjName()"
            [id]="inputId() || undefined"
            [isRequired]="isRequired()"
            [isReadOnly]="controlDisabled()"
        ></wj-input-date>
    </div>
</div>
